/* generated by theme/yoby/scripts/gen-portal-locales.mjs — do not edit */
window.YOBY_PORTAL_TIERS = {
  "en": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-10-08T13:38:24.444Z",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Free",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "School Supervisor",
        "description": "Internal plan for school supervisors",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "School Teacher",
        "description": "Internal plan for teachers.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "YOBY Family",
        "description": "YOBY is the digital world where kids and parents explore ponds, meet mentors and build healthy financial habits — together, every day.",
        "benefits": [
          "Family pond",
          "All mentor characters",
          "Sky level unlocked",
          "Underground level unlocked",
          "More collectibles"
        ],
        "trialDays": 15,
        "trialBadge": "15 days free"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "YOBY Patron",
        "description": "For early supporters who believe financial education should be playful, safe, and shared by the whole family.",
        "benefits": [
          "The same of YOBY Family plus:",
          "Premium collectibles at the start of the game",
          "Early Access to new game features"
        ],
        "trialDays": 15,
        "trialBadge": "15 days free"
      }
    ],
    "signupTermsHtml": "<p dir=\"ltr\"><span>I agree to terms and conditions, and I read the Privacy Policy.</span></p>",
    "locale": "en"
  },
  "it": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "it",
    "signupTermsHtml": "<p>Accetto i <a href=\"/terms-of-service/\">termini e condizioni</a> e ho letto l'<a href=\"/privacy-policy/\">informativa sulla privacy</a>.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Gratuito",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Supervisore Scolastico",
        "description": "Piano interno per i supervisori scolastici",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Insegnante Scolastico",
        "description": "Piano interno per gli insegnanti.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "YOBY Famiglia",
        "description": "YOBY è il mondo digitale dove bambini e genitori esplorano stagni, incontrano mentori e costruiscono abitudini finanziarie sane — insieme, ogni giorno.",
        "benefits": [
          "Stagno familiare",
          "Tutti i personaggi mentori",
          "Livello cielo sbloccato",
          "Livello sotterraneo sbloccato",
          "Più collezionabili"
        ],
        "trialDays": 15,
        "trialBadge": "15 giorni gratis"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "Patrono YOBY",
        "description": "Per i primi sostenitori che credono che l'educazione finanziaria debba essere giocosa, sicura e condivisa da tutta la famiglia.",
        "benefits": [
          "Gli stessi vantaggi di YOBY Famiglia più:",
          "Collezionabili premium all'inizio del gioco",
          "Accesso anticipato a nuove funzionalità del gioco"
        ],
        "trialDays": 15,
        "trialBadge": "15 giorni gratis"
      }
    ]
  },
  "fr": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "fr",
    "signupTermsHtml": "<p>J'accepte les <a href=\"/terms-of-service/\">conditions générales</a> et j'ai lu la <a href=\"/privacy-policy/\">politique de confidentialité</a>.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Gratuit",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Superviseur Scolaire",
        "description": "Plan interne pour les superviseurs scolaires",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Enseignant Scolaire",
        "description": "Plan interne pour les enseignants.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "Famille YOBY",
        "description": "YOBY est le monde numérique où les enfants et les parents explorent des étangs, rencontrent des mentors et construisent des habitudes financières saines — ensemble, chaque jour.",
        "benefits": [
          "Étang familial",
          "Tous les personnages mentors",
          "Niveau ciel débloqué",
          "Niveau souterrain débloqué",
          "Plus de collectibles"
        ],
        "trialDays": 15,
        "trialBadge": "15 jours gratuits"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "Patron YOBY",
        "description": "Pour les premiers soutiens qui croient que l'éducation financière doit être ludique, sûre et partagée par toute la famille.",
        "benefits": [
          "Les mêmes avantages que Famille YOBY plus :",
          "Collectibles premium au début du jeu",
          "Accès anticipé aux nouvelles fonctionnalités du jeu"
        ],
        "trialDays": 15,
        "trialBadge": "15 jours gratuits"
      }
    ]
  },
  "es": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "es",
    "signupTermsHtml": "<p>Acepto los <a href=\"/terms-of-service/\">términos y condiciones</a> y he leído la <a href=\"/privacy-policy/\">política de privacidad</a>.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Gratis",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Supervisor Escolar",
        "description": "Plan interno para supervisores escolares",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Profesor Escolar",
        "description": "Plan interno para profesores.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "Familia YOBY",
        "description": "YOBY es el mundo digital donde los niños y los padres exploran estanques, conocen mentores y construyen hábitos financieros saludables, juntos, todos los días.",
        "benefits": [
          "Estanque familiar",
          "Todos los personajes mentores",
          "Nivel cielo desbloqueado",
          "Nivel subterráneo desbloqueado",
          "Más coleccionables"
        ],
        "trialDays": 15,
        "trialBadge": "15 días gratis"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "Patrón YOBY",
        "description": "Para los primeros apoyadores que creen que la educación financiera debe ser lúdica, segura y compartida por toda la familia.",
        "benefits": [
          "Lo mismo que Familia YOBY más:",
          "Coleccionables premium al inicio del juego",
          "Acceso anticipado a nuevas funciones del juego"
        ],
        "trialDays": 15,
        "trialBadge": "15 días gratis"
      }
    ]
  },
  "pt": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "pt",
    "signupTermsHtml": "<p>Aceito os <a href=\"/terms-of-service/\">termos e condições</a> e li a <a href=\"/privacy-policy/\">política de privacidade</a>.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Gratuito",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Supervisor Escolar",
        "description": "Plano interno para supervisores escolares",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Professor Escolar",
        "description": "Plano interno para professores.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "Família YOBY",
        "description": "YOBY é o mundo digital onde crianças e pais exploram lagoas, conhecem mentores e constroem hábitos financeiros saudáveis — juntos, todos os dias.",
        "benefits": [
          "Lagoa da família",
          "Todos os personagens mentores",
          "Nível céu desbloqueado",
          "Nível subterrâneo desbloqueado",
          "Mais colecionáveis"
        ],
        "trialDays": 15,
        "trialBadge": "15 dias grátis"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "Patrono YOBY",
        "description": "Para apoiadores iniciais que acreditam que a educação financeira deve ser lúdica, segura e compartilhada por toda a família.",
        "benefits": [
          "Os mesmos benefícios da Família YOBY mais:",
          "Colecionáveis premium no início do jogo",
          "Acesso antecipado a novos recursos do jogo"
        ],
        "trialDays": 15,
        "trialBadge": "15 dias grátis"
      }
    ]
  },
  "de": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "de",
    "signupTermsHtml": "<p>Ich stimme den <a href=\"/terms-of-service/\">Nutzungsbedingungen</a> zu und habe die <a href=\"/privacy-policy/\">Datenschutzerklärung</a> gelesen.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Kostenlos",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Schulaufsicht",
        "description": "Interner Plan für Schulaufsichten",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Lehrer",
        "description": "Interner Plan für Lehrer.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "YOBY Familie",
        "description": "YOBY ist die digitale Welt, in der Kinder und Eltern Teiche erkunden, Mentoren treffen und gemeinsam gesunde finanzielle Gewohnheiten aufbauen – jeden Tag.",
        "benefits": [
          "Familienteich",
          "Alle Mentor-Charaktere",
          "Himmel-Level freigeschaltet",
          "Untergrund-Level freigeschaltet",
          "Mehr Sammlerstücke"
        ],
        "trialDays": 15,
        "trialBadge": "15 Tage kostenlos"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "YOBY Förderer",
        "description": "Für frühe Unterstützer, die glauben, dass finanzielle Bildung spielerisch, sicher und von der ganzen Familie geteilt werden sollte.",
        "benefits": [
          "Das Gleiche wie YOBY Familie plus:",
          "Premium-Sammlerstücke zu Beginn des Spiels",
          "Früher Zugang zu neuen Spiel-Features"
        ],
        "trialDays": 15,
        "trialBadge": "15 Tage kostenlos"
      }
    ]
  },
  "nl": {
    "sourceHash": "56e1712acc7520b479d17ab8e4ef2871bb476ab0a7622f1de9bef2db7e14fe26",
    "fetchedAt": "2026-07-13T12:47:40.462Z",
    "locale": "nl",
    "signupTermsHtml": "<p>Ik ga akkoord met de <a href=\"/terms-of-service/\">algemene voorwaarden</a> en ik heb het <a href=\"/privacy-policy/\">privacybeleid</a> gelezen.</p>",
    "tiers": [
      {
        "ghostId": "6a476ee477abea895847e418",
        "matchName": "Free",
        "name": "Gratis",
        "description": "",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6fc16d7c1f83c4a1ba2d",
        "matchName": "School Supervisor",
        "name": "Schooltoezichthouder",
        "description": "Intern plan voor schooltoezichthouders",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a4f6faf6d7c1f83c4a1ba29",
        "matchName": "School Teacher",
        "name": "Schoolleraar",
        "description": "Intern plan voor leraren.",
        "benefits": [],
        "trialDays": 0,
        "trialBadge": null
      },
      {
        "ghostId": "6a476ee477abea895847e419",
        "matchName": "YOBY Family",
        "name": "YOBY Familie",
        "description": "YOBY is de digitale wereld waar kinderen en ouders vijvers verkennen, mentoren ontmoeten en samen gezonde financiële gewoonten opbouwen — elke dag.",
        "benefits": [
          "Familievijver",
          "Alle mentorpersonages",
          "Lucht niveau ontgrendeld",
          "Ondergrond niveau ontgrendeld",
          "Meer verzamelobjecten"
        ],
        "trialDays": 15,
        "trialBadge": "15 dagen gratis"
      },
      {
        "ghostId": "6a4bc6b60559e4ed3c522d8d",
        "matchName": "YOBY Patron",
        "name": "YOBY Patron",
        "description": "Voor vroege supporters die geloven dat financiële educatie speels, veilig en gedeeld moet worden door het hele gezin.",
        "benefits": [
          "Hetzelfde als YOBY Familie plus:",
          "Premium verzamelobjecten aan het begin van het spel",
          "Vroeg toegang tot nieuwe spelkenmerken"
        ],
        "trialDays": 15,
        "trialBadge": "15 dagen gratis"
      }
    ]
  }
};
